import React, {useCallback, useEffect, useMemo, useRef, useState} from "react"
import DateBox from "devextreme-react/date-box";
import Button from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import {useAuth} from "../../contexts/auth";
import {getKdGtp, getGtpPlan, updGtpPlan, getFileExcel, sendGtpPlan, copyPasteGTPPlan, loadRppMonth, importGtpExcel, clearGtpPlan} from "../../api/plan";
import DropDownButton from "devextreme-react/drop-down-button";
import {SelectBox} from "devextreme-react/select-box";
import DataGrid, {Column, Sorting, Editing, KeyboardNavigation, Paging, PatternRule} from "devextreme-react/data-grid";
import Toolbar, { Item } from 'devextreme-react/toolbar';
import {CheckBox, TextBox} from "devextreme-react";
import {Buffer} from "buffer";
import LoadPanel from "devextreme-react/load-panel";
import AccessDenied from "../../components/access-denied/access-denied";
import {verifyAccess} from "../../utils/admin.utils"
import {isAdminRoleChecker} from "../../utils/roleChecker"
import {USER_ROLES} from "../../constants/roles";
import './planning.scss'
import Popup from "devextreme-react/popup";
import ScrollView from 'devextreme-react/scroll-view'
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon";
import {getddMMyyyy, getyyyyMMdd, formatMskClockLocal} from "../../utils/date.utils";
import { ProgressBar } from 'devextreme-react/progress-bar';
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import {useScreenSize} from "../../utils/media-query";

function statusFormat(ratio) {
    return `Копирование: ${(ratio * 100).toFixed(0)}%`;
}

const MONTHS_RU = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];

function isFilledVal(v) {
    return v !== null && v !== undefined && v !== ''
}

function planDateKeys(row) {
    if (!row) return []
    return Object.keys(row).filter(k => k !== 'hours' && !String(k).startsWith('rpp_'))
}

function dayFillStatus(rows, dateKey) {
    if (!rows?.length) return 'empty'
    let filled = 0
    let empty = 0
    for (const row of rows) {
        if (isFilledVal(row[dateKey])) filled++
        else empty++
    }
    if (filled === 0) return 'empty'
    if (empty > 0) return 'partial'
    return 'complete'
}

function dayHasAverageAnomaly(rows, dateKey) {
    const arr = rows.map(r => r[dateKey]).filter(v => isFilledVal(v) && Number(v) !== 0)
    if (arr.length === 0) return false
    const sum = arr.reduce((s, v) => s + Number(v), 0)
    const limit = (sum / arr.length) * 2
    return rows.some(r => isFilledVal(r[dateKey]) && Number(r[dateKey]) > limit)
}

function clockParts(value, fallbackHour, fallbackMin) {
    let hour = fallbackHour
    let min = fallbackMin
    if (value) {
        const parts = String(value).split(':')
        const h = parseInt(parts[0], 10)
        const m = parseInt(parts[1], 10)
        if (!Number.isNaN(h)) hour = h
        if (!Number.isNaN(m)) min = m
    }
    return { hour, min }
}

function averageLimit(rows, dateKey) {
    const arr = rows.map(r => r[dateKey]).filter(v => isFilledVal(v) && Number(v) !== 0)
    if (arr.length === 0) return null
    const sum = arr.reduce((s, v) => s + Number(v), 0)
    return (sum / arr.length) * 2
}

const Planning = () => {
    // дата добавляем дни
    // eslint-disable-next-line no-extend-native
    Date.prototype.ieAddDays = function(days) {
        let date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    // дата без времени
    // eslint-disable-next-line no-extend-native
    Date.prototype.ieSetH0 = function() {
        return new Date(this.setUTCHours(0, 0, 0, 0));
    }

    function getLastDayOfNextMonth() {
        const now = new Date();
        // Берем первый день месяца, который идет через 2 месяца, и вычитаем 1 день
        const firstDayOfMonthAfterNext = new Date(now.getFullYear(), now.getMonth() + 2, 1);
        firstDayOfMonthAfterNext.setDate(firstDayOfMonthAfterNext.getDate());
        return firstDayOfMonthAfterNext.ieSetH0();
    }

    const datenow = new Date().ieSetH0()
    let dnow = new Date(datenow.setDate(datenow.getDate() + 2))
    //const [min1, setMin1] = useState(dnow)
    // По ТЗ: дефолтный диапазон таблицы [X-1; X+4]
    const [period1, setPeriod1] = useState(() => new Date().ieSetH0().ieAddDays(-1))
    const [period2, setPeriod2] = useState(() => new Date().ieSetH0().ieAddDays(4))
    // Дедлайн корректировки X+1 из cc_gtp_kodes.correction_time (МСК)
    const [correctionHour, setCorrectionHour] = useState(10)
    const [correctionMin, setCorrectionMin] = useState(0)
    // Время автоотправки X+2 из cc_gtp_kodes.auto_send_time (МСК)
    const [autoSendHour, setAutoSendHour] = useState(13)
    const [autoSendMin, setAutoSendMin] = useState(0)
    const correctRef = useRef(false)
    // popup
    const [period3, setPeriod3] = useState(new Date().ieSetH0().ieAddDays(1))
    const [period4, setPeriod4] = useState(dnow)
    const [period5, setPeriod5] = useState(dnow)
    const [raznDayCount, setRaznDayCount] = useState((period5 - period4)/(1000*3600*24)+1)
    const [visible, setVisible] = useState(false)
    const [updatingPanel, setUpdatingPanel] = useState(false)
    // Popup «Очистить планирование»
    const [clearVisible, setClearVisible] = useState(false)
    const [clearFrom, setClearFrom] = useState(() => new Date().ieSetH0().ieAddDays(2))
    const [clearTo, setClearTo]     = useState(() => new Date().ieSetH0().ieAddDays(2))
    const [clearLoading, setClearLoading] = useState(false)
    const [seconds, setSeconds] = useState(((period5 - period4)/(1000*3600*24)+1)*24);
    const [maxValue, setMaxValue] = useState(((period5 - period4)/(1000*3600*24)+1)*24);

    const { selectedDog, user, impersonate } = useAuth()
    const { isXSmall, isSmall } = useScreenSize()
    const isMobile = isXSmall || isSmall  // < 960px — мобильный вид тулбара
    const importFileRef = useRef(null)
    const gridRef = useRef(null)
    const savesPendingRef = useRef(0)
    const [data, setData] = useState([])
    const [kdGtps, setKdGtps] = useState([])
    const [kdGtp, setKdGtp] = useState(null)
    const [columns, setColumns] = useState(null)
    const [summary, setSummary] = useState(null)
    const [correct, setCorrect] = useState(false)
    const [loadingFile, setLoadingFile] = useState(false)
    const [loading, setLoading] = useState(true)
    const [visiblePage, setVisiblePage] = useState(true)
    const [loadExcel, setLoadExcel] = useState(false)
    /*const [css, setCss] = useState('')*/
    const formatnumber = "###,###,###,###,##0.###"
    const formatnumberCols = "###0.###"
    const [correctionDay, setCorrectionDay] = useState(null)
    const maxDate = useMemo(() => getLastDayOfNextMonth(), []);
    const minDate = useMemo(() => new Date('09/01/2024'), []);
    const [messageError, setMessageError] = useState(null)
    // Настройки из cc_gtp_kodes (заполняет АСУСЭ)
    const [planningEnabled, setPlanningEnabled] = useState(true)  // показывать форму
    const [showRpp, setShowRpp] = useState(false)
    const [pMin, setPMin] = useState(null)   // Pmin потребителя
    const [pMax, setPMax] = useState(null)   // Pmax потребителя
    // Sent-lock: даты, за которые заявка уже подана
    const [sentDates, setSentDates] = useState(new Set())
    const [emptyErrorDates, setEmptyErrorDates] = useState(new Set())
    const [averageErrorDates, setAverageErrorDates] = useState(new Set())
    /*const [copyWeekValue, setCopyWeekValue] = useState(false)
    const [copyFactValue, setCopyFactValue] = useState(false)*/

    const copyRppToPlan = useCallback(async (dateStr, hour, value) => {
        if (value == null) return false
        const h = hour < 10 ? '0' + hour : hour
        const res = await updGtpPlan(kdGtp, `${dateStr} ${h}:00:00`, value, selectedDog.kodDog)
        if (res?.isOk) {
            setData(prev => prev.map(row => row.hours === hour ? { ...row, [dateStr]: value } : row))
            return true
        }
        notify(res?.message || 'Не удалось перенести значение РПП', 'error', 4000)
        return false
    }, [kdGtp, selectedDog.kodDog])

    const copyRppColumn = useCallback(async (dateStr, rppHours) => {
        let ok = 0
        for (let hour = 0; hour <= 23; hour++) {
            const val = rppHours[hour] ?? rppHours[String(hour)]
            if (val == null) continue
            if (await copyRppToPlan(dateStr, hour, val)) ok++
        }
        if (ok) notify(`Перенесено ${ok} значений прогноза в план`, 'success', 3000)
    }, [copyRppToPlan])

    // Виден только администраторам или в режиме имперсонации
    const canClearPlan = isAdminRoleChecker(user, USER_ROLES.ADMIN) || !!impersonate

    const onClearPlan = async () => {
        if (!kdGtp || !clearFrom || !clearTo) return
        setClearLoading(true)
        const dtBegin = getyyyyMMdd(clearFrom)
        const dtEnd   = getyyyyMMdd(clearTo)
        const res = await clearGtpPlan(kdGtp, selectedDog.kodDog, dtBegin, dtEnd)
        setClearLoading(false)
        if (res?.isOk) {
            notify(`Данные за ${dtBegin} – ${dtEnd} очищены`, 'success', 4000)
            setSentDates(new Set())
            setClearVisible(false)
            await getDataGrid()
        } else {
            notify(res?.message || 'Ошибка при очистке данных', 'error', 5000)
        }
    }

    const rppMenuItems = useMemo(() => {
        const now = new Date()
        const next = new Date(now.getFullYear(), now.getMonth() + 1, 1)
        return [
            { id: 0, text: `РПП на ${MONTHS_RU[now.getMonth()]} ${now.getFullYear()}` },
            { id: 1, text: `РПП на ${MONTHS_RU[next.getMonth()]} ${next.getFullYear()}` },
        ]
    }, [])

    const getDataGrid = useCallback(async () => {
        setMessageError(null)
        if (!kdGtp || period1.ieSetH0() > period2.ieSetH0()) return;
        if (period1 > period2 || period2 > maxDate || period1 < minDate || period2 < period1) {
            console.log('Ошибка в диапазоне дат')
            return;
        }
        setLoading(true)
        try {
        const res = await getGtpPlan(kdGtp, period1, period2, selectedDog.kodDog)
        if (res.isOk) {
            if (!res.result || !res.result.length) {
                setData([])
                setColumns(null)
                return
            }
            // По ТЗ: Факт = X и ранее; X+1 = план, но заблокирован вне режима Корректировки
            let datenow = new Date().ieSetH0()
            let todayInt    = parseInt(getyyyyMMdd(datenow).replace(/-/gs,''))
            let tomorrowStr = getyyyyMMdd(datenow.ieAddDays(1))
            let tomorrowInt = parseInt(tomorrowStr.replace(/-/gs,''))
            const rppHours = res.rpp?.[tomorrowStr] || {}
            const hasRpp = (showRpp || res.show_rpp) && Object.keys(rppHours).length > 0
            const rppField = 'rpp_' + tomorrowStr
            const gridRows = res.result.map(row => ({
                ...row,
                [rppField]: rppHours[row.hours] ?? rppHours[String(row.hours)] ?? null
            }))
            setData(gridRows)

            const columnsKeys = Object.keys(res.result[0]).filter(k => k !== 'hours' && !String(k).startsWith('rpp_'))
            let cols = [{width: 140, dataField: "hours",caption: "Час суток поставки", fixed: true, allowEditing: false}]
            let colsInner = []
            let sum = []
            const sentFromApi = Array.isArray(res.sent)
                ? new Set(res.sent.map(d => String(d).slice(0, 10)))
                : sentDates

            for (let t = 0; t < columnsKeys.length; t++) {
                const dateKey = columnsKeys[t]
                let colInt = parseInt(dateKey.replace(/-/gs,''))
                let isFactCol = colInt <= todayInt
                let isLockedTomorrow = colInt === tomorrowInt && !correct
                let isSentLocked = sentFromApi.has(dateKey) && !correct
                let disabled = isFactCol || isLockedTomorrow || isSentLocked
                let caption = isFactCol ? 'Факт\r\n' : isSentLocked ? 'Подано\r\n' : 'План\r\n'
                let colClass = (isFactCol || isLockedTomorrow) ? 'ie-cels-disabled' : isSentLocked ? 'ie-cels-sent' : ''
                colsInner.push({caption: caption + dateKey, dataField: dateKey, minWidth:90, dataType: "number", encodeHtml: false,
                    format: formatnumberCols,
                    className: colClass, cssClass: 'multiline-header',
                    editorOptions: {max:9999, min:0, format: {precision: 3}, disabled: disabled}
                })
                sum.push({column: dateKey, summaryType:"sum", valueFormat:formatnumber})

                if (hasRpp && String(dateKey).slice(0, 10) === tomorrowStr) {
                    colsInner.push({
                        caption: 'Прогноз системы\r\n' + tomorrowStr,
                        dataField: rppField,
                        minWidth: 110,
                        dataType: 'number',
                        allowEditing: false,
                        format: formatnumberCols,
                        cssClass: 'multiline-header ie-rpp-col',
                        headerCellTemplate: (container) => {
                            const wrap = document.createElement('div')
                            wrap.className = 'ie-rpp-header'
                            if (correct) {
                                const arrow = document.createElement('span')
                                arrow.className = 'ie-rpp-arrow'
                                arrow.textContent = '← '
                                arrow.title = 'Перенести весь столбец в план'
                                arrow.onclick = (e) => { e.stopPropagation(); copyRppColumn(tomorrowStr, rppHours) }
                                wrap.appendChild(arrow)
                            }
                            const title = document.createElement('span')
                            title.innerText = 'Прогноз системы\n' + tomorrowStr
                            wrap.appendChild(title)
                            container.appendChild(wrap)
                        },
                        cellTemplate: (container, options) => {
                            const wrap = document.createElement('div')
                            wrap.className = 'ie-rpp-cell'
                            if (correct) {
                                const arrow = document.createElement('span')
                                arrow.className = 'ie-rpp-arrow'
                                arrow.textContent = '←'
                                arrow.title = 'Перенести в план'
                                arrow.onclick = (e) => { e.stopPropagation(); copyRppToPlan(tomorrowStr, options.data.hours, options.value) }
                                wrap.appendChild(arrow)
                            }
                            const val = document.createElement('span')
                            val.textContent = options.value == null ? '' : options.value
                            wrap.appendChild(val)
                            container.appendChild(wrap)
                        }
                    })
                    sum.push({column: rppField, summaryType:"sum", valueFormat:formatnumber})
                }
            }
            cols.push({caption:'Плановые максимальные почасовые объемы потребления электрической энергии, МВтч', columns:colsInner, allowEditing: false, className: "header-left", fixedPosition: 'left'})
           /* cols.push({caption:"Итого", dataType: "number",allowEditing:false, calculateCellValue: (data) => {
                    let sum = 0;
                    for (let t = 1; t <= columnsCount; t++) {
                        sum += data[columnsKeys[t]]
                    }
                    return sum
                }
            })*/
            setColumns(cols)
            setSummary({totalItems:sum})
            if (Array.isArray(res.sent)) {
                setSentDates(prev => {
                    const next = new Set(res.sent.map(d => String(d).slice(0, 10)))
                    if (prev.size === next.size && [...next].every(d => prev.has(d))) return prev
                    return next
                })
            }
        } else {
            setData([])
            notify(res.message,'error',5000)
        }
        } finally {
            setLoading(false)
        }
    },[kdGtp, period2, period1, correct, maxDate, minDate, selectedDog.kodDog, sentDates, showRpp, copyRppToPlan, copyRppColumn])

    const onImportExcel = useCallback(async (file) => {
        if (!file) return
        setLoadingFile(true)
        try {
            const buf = await file.arrayBuffer()
            const b64 = Buffer.from(buf).toString('base64')
            const res = await importGtpExcel(kdGtp, selectedDog.kodDog, b64, correct)
            if (res.isOk) {
                notify(res.message, 'success', 4000)
                await getDataGrid()
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message || 'Ошибка чтения файла', 'error', 5000)
        } finally {
            setLoadingFile(false)
            if (importFileRef.current) importFileRef.current.value = ''
        }
    }, [kdGtp, selectedDog.kodDog, correct, getDataGrid])

    const onRppMonth = useCallback(async (monthOffset) => {
        setLoadingFile(true)
        const res = await loadRppMonth(kdGtp, selectedDog.kodDog, monthOffset)
        setLoadingFile(false)
        if (res.isOk) {
            notify(res.message, res.filled ? 'success' : 'warning', 4000)
            await getDataGrid()
        } else {
            notify(res.message, 'error', 5000)
        }
    }, [kdGtp, selectedDog.kodDog, getDataGrid])

    // Применить настройки выбранной ГТП из ответа get-kd-gtp
    const applyGtpSettings = useCallback((gtpData) => {
        setPlanningEnabled(gtpData?.planning_enabled ?? true)
        setShowRpp(!!gtpData?.show_rpp)
        setPMin(gtpData?.p_min != null ? Number(gtpData.p_min) : null)
        setPMax(gtpData?.p_max != null ? Number(gtpData.p_max) : null)
        const corr = clockParts(gtpData?.correction_time, 10, 0)
        setCorrectionHour(corr.hour)
        setCorrectionMin(corr.min)
        const auto = clockParts(gtpData?.auto_send_time, 13, 0)
        setAutoSendHour(auto.hour)
        setAutoSendMin(auto.min)
        // Сбрасываем sent-lock при смене ГТП
        setSentDates(new Set())
    }, [])

    useEffect(() => {
        const pageRoles = [2]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return
        }
        (async function(){
            setVisiblePage(true)
            setLoading(true)
            //получаем список ГТП по договору
            const res = await getKdGtp(selectedDog.kodDog)
            if (res.isOk && res.result && res.result.length > 0) {
                setKdGtps(res.result)
                setKdGtp(res.result[0].kod_gtp)
                applyGtpSettings(res.result[0])
            } else {
                //notify(res.message ?? 'Для данного договора не заданы ГТП', 'error', 5000)
                setData([])
                setKdGtps([])
                setKdGtp(null)
                setPlanningEnabled(false)
                setLoading(false)
            }
        })()
    }, [selectedDog, applyGtpSettings])

    useEffect(() => {
        (async function(){
                await getDataGrid()
        })()
    },[getDataGrid])

    useEffect(() => {
        gridRef.current?.instance?.repaint?.()
    }, [emptyErrorDates, averageErrorDates])

    useEffect(() => {
        (async function(){
            setCorrectionDay(getyyyyMMdd(new Date().ieAddDays(1)))
        })()
    },[])

    const onValueChangedSelectBox = useCallback((e) => {
        setKdGtp(e.value);
        const selectedGtp = kdGtps.find(g => g.kod_gtp === e.value)
        if (selectedGtp) applyGtpSettings(selectedGtp)
    }, [kdGtps, applyGtpSettings]);

    const onValueCorrectChanged = (e) => {
        correctRef.current = e
        setCorrect(e);
        let datenow = new Date().ieSetH0()
        let day = e ? 1 : 2
        let dnow = datenow.ieAddDays(day)
        //предотвращаем лишние срабатывания отбрасывая время
        if (dnow > period2) {
            setPeriod2(dnow)
        }
        if (dnow > period1) {
            //setPeriod1(dnow)
        }
        /*if (e) setCss('')*/
    };

    /*const onWeekCopyChanged = (e) => {
        setCopyWeekValue(e.value);
        setPeriod5(new Date(new Date().setDate(new Date(period4).getDate() + 6)).ieSetH0())
    };*/

    const onRowUpdating = async (e) => {
        const rowData = e.newData
        let day = Object.keys(rowData)[0]
        let value = Object.values(rowData)[0]
        const dateKey = day
        // Pmin/Pmax валидация
        if (value !== null && value !== undefined) {
            if (pMin !== null && value < pMin) {
                notify(`Внесённое значение ниже Pmin=${pMin}`, 'warning', 4000)
            }
            if (pMax !== null && value > pMax) {
                notify(`Внесённое значение превышает Pmax=${pMax}`, 'warning', 4000)
            }
        }
        // вычисляем превышение на 100%
        let arr = e.component.getDataSource()._items.map(row => row[day]).filter(v => v !== null && v !== 0)
        let sum = arr.reduce((s,v) => s + v, 0)
        let average = (sum / arr.length) * 2
        if (value > average && arr.length > 1) {
            notify(`Внесённое значение превышает факт (${(average/2).toFixed(3)}) более чем на 100%`, 'error', 3000)
        }
        let hour = e.key < 10 ? '0' + e.key : e.key
        day = `${day} ${hour}:00:00`
        savesPendingRef.current += 1
        try {
            const res = await updGtpPlan(kdGtp, day, value, selectedDog.kodDog)
            if (res?.isOk) {
                setData(prev => prev.map(row => row.hours === e.key ? { ...row, [dateKey]: value } : row))
                return true
            }
            notify(res.message,'error',5000)
            return {}
        } finally {
            savesPendingRef.current -= 1
        }
    }

    const onCellPrepared = async (e) => {
        if (e.rowType === 'data' && e.column.name === 'hours') {
            let hour = e.data.hours, hourNext = +e.data.hours + 1
            if (hour < 10) hour = `0${hour}`
            if (hourNext < 10) hourNext = `0${hourNext}`
            hour = `${hour}:00 - ${hourNext}:00`
            e.cellElement.innerHTML = hour
        }
        if (e.rowType === 'data' && correct && e.column.index > 0 && e.column.name === correctionDay) {
            e.cellElement?.classList.add('ie-correction-col')
        }
        // подкрашиваем задизабленные (факт)
        if (e.column.className === "ie-cels-disabled") {
            e.cellElement?.classList.add('ie-cels-disabled')
        }
        // подкрашиваем поданные (sent-lock): серый, только вне режима корректировки
        if (e.rowType === 'data' && e.column.index > 0 && sentDates.has(e.column.dataField) && !correct) {
            e.cellElement?.classList.add('ie-cels-sent')
        }
        // в режиме корректировки — подсвечиваем голубым ранее поданные сутки
        if (e.rowType === 'data' && e.column.index > 0 && sentDates.has(e.column.dataField) && correct) {
            e.cellElement?.classList.add('ie-correction-col')
        }
        if (e.rowType === 'data' && e.column.index > 0) {
            const key = e.column.dataField
            if (emptyErrorDates.has(key) && !isFilledVal(e.value)) {
                e.cellElement?.classList.add('ie-error')
            }
            if (averageErrorDates.has(key) && isFilledVal(e.value)) {
                const items = e.component.getDataSource()._items || []
                const limit = averageLimit(items, key)
                if (limit != null && Number(e.value) > limit) {
                    e.cellElement?.classList.add('ie-error')
                }
            }
        }
        //подсветка для валидации Pmin/Pmax
        //index > 0 пропускает столбец «Час суток», rpp_ — столбец прогноза
        if (
            e.rowType === 'data' &&
            e.column.index > 0 &&
            !String(e.column.dataField).startsWith('rpp_') &&
            isFilledVal(e.value)
        ) {
            const n = Number(e.value)
            if ((pMin !== null && n < pMin) || (pMax !== null && n > pMax)) {
                e.cellElement?.classList.add('ie-error')
            }
        }
    }

    const onContentReady = async () => {
        let err = null
        if (loadExcel) {
            await loadFileExcel()
        }
        setMessageError(err)
        setLoadExcel(false)
    }

    const onDateBox1Changed = (e) => {
        if (e.event === undefined) return
        // при превышении даты начала над датой конца сдвигам конец в начало
        if (e.value.ieSetH0() > period2) {
            setPeriod2(e.value.ieSetH0())
        }
        setPeriod1(e.value.ieSetH0())
    }

    const onDateBox2Changed = (e) => {
        setPeriod2(e.value.ieSetH0())
    }

    const onDateBox4Changed = (e) => {
        if (e.event === undefined) return
        // при превышении даты начала над датой конца сдвигам конец в начало
        if (e.value.ieSetH0() > period5) setPeriod5(e.value.ieSetH0())
        setPeriod4(e.value.ieSetH0())
        let days = Math.round((period5 - e.value.ieSetH0())/(1000*3600*24)+1)
        setRaznDayCount( days)
        setMaxValue(days*24)
        setSeconds(days*24)
    }

    const onDateBox5Changed = (e) => {
        setPeriod5(e.value.ieSetH0())
        let days = Math.round((e.value.ieSetH0() - period4)/(1000*3600*24) + 1)
        setRaznDayCount(days)
        setMaxValue(days*24)
        setSeconds(days*24)
    }

    async function loadFileExcel() {
        try {
            const res = await getFileExcel( kdGtp, period1, period2, selectedDog.kodDog )
            if (res.isOk) {
                const file = res.result.content
                const filename = res.result.filename
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(file), filename)
            } else {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {

        }
    }

    /*async function checkAllHoursSet(){
        const res = await getGtpPlan(kdGtp, period1, period2)
        if (res.isOk) {
            let arr = res.result.filter(e => Object.keys(e).find(key => e[key] === null))
            return arr.length !== 0
        }
    }*/

    const deadlineHintMessage = useMemo(() => {
        const x1 = new Date().ieSetH0().ieAddDays(1)
        const x2 = new Date().ieSetH0().ieAddDays(2)
        // времена в БД — МСК; на экране — пояс ОС
        const corrLocal = formatMskClockLocal(correctionHour, correctionMin)
        const autoLocal = formatMskClockLocal(autoSendHour, autoSendMin)
        return [
            `Корректировка заявки на сутки ${getddMMyyyy(x1)} возможна до ${corrLocal}`,
            `Подача заявки на сутки ${getddMMyyyy(x2)} возможна до ${autoLocal}`,
        ].join('\n')
    }, [correctionHour, correctionMin, autoSendHour, autoSendMin])

    const waitPendingSaves = async () => {
        const inst = gridRef.current?.instance
        if (inst?.saveEditData) {
            try { await inst.saveEditData() } catch (e) { /* ячейка могла быть уже закрыта */ }
        }
        let n = 0
        while (savesPendingRef.current > 0 && n < 80) {
            await new Promise(r => setTimeout(r, 50))
            n++
        }
    }

    const onSubmitPlan = async () => {
        setEmptyErrorDates(new Set())
        setAverageErrorDates(new Set())
        await waitPendingSaves()
        const instItems = gridRef.current?.instance?.getDataSource()?.items()
        const rows = (instItems && instItems.length) ? instItems : data
        if (!rows.length) {
            notify('Нет данных для отправки', 'error', 4000)
            return
        }
        const todayInt = parseInt(getyyyyMMdd(new Date().ieSetH0()).replace(/-/g, ''), 10)
        const keys = planDateKeys(rows[0]).filter(k => {
            const colInt = parseInt(String(k).replace(/-/g, ''), 10)
            if (colInt <= todayInt) return false
            const d = new Date(k)
            return d >= period1 && d <= period2
        })
        const partial = []
        const complete = []
        const avgBad = []
        for (const key of keys) {
            const st = dayFillStatus(rows, key)
            if (st === 'empty') continue
            if (st === 'partial') {
                partial.push(key)
                continue
            }
            if (dayHasAverageAnomaly(rows, key)) {
                avgBad.push(key)
                continue
            }
            complete.push(key)
        }
        setEmptyErrorDates(new Set(partial))
        setAverageErrorDates(new Set(avgBad))

        if (partial.length && complete.length === 0 && avgBad.length === 0) {
            notify('Есть неполностью заполненные сутки. Заполните все 24 часа или оставьте сутки пустыми.', 'error', 5000)
            return
        }
        if (avgBad.length && complete.length === 0) {
            notify('Некоторые значения превышают факт более чем на 100%', 'error', 5000)
            return
        }
        if (complete.length === 0) {
            notify('Нет полных суток для отправки', 'error', 4000)
            return
        }

        setLoadingFile(true)
        try {
            const days = {}
            for (const key of complete) {
                const hours = {}
                for (const row of rows) {
                    hours[String(row.hours)] = row[key]
                }
                days[key] = hours
            }
            const res = await sendGtpPlan(kdGtp, period1, period2, selectedDog.kodDog, correct, days)
            if (res.isOk) {
                notify(res.message, 'success', 5000)
                if (res.sent?.length) {
                    setSentDates(prev => {
                        const next = new Set(prev)
                        res.sent.forEach(d => next.add(String(d).slice(0, 10)))
                        return next
                    })
                }
                if (res.skipped_partial?.length) {
                    setEmptyErrorDates(new Set(res.skipped_partial.map(d => String(d).slice(0, 10))))
                }
            } else {
                notify(res.message || 'Ошибка отправки', 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        } finally {
            setLoadingFile(false)
        }
    }

    /*const copyDays = async() => {
        try {
            let objArr = []
            setUpdatingPanel(true)
            const res = await getGtpPlan(kdGtp, period3, period3)
            if (!res.isOk) {
                notify(res.message, 'warning', 5000)
                return null
            }

            let id_gtp = kdGtp;
            let hours = res.result;
            setMaxValue(raznDayCount*24)
            setSeconds(raznDayCount*24)
            for (let countDay = 0; countDay < raznDayCount; countDay++) {
                let diapazonDataCurrent = new Date(period4).ieAddDays(countDay);
                for (let hour of hours) {
                    let dt = `${getyyyyMMdd(diapazonDataCurrent)} ${hour.hours.toString().padStart(2, '0')}:00:00`
                    let val = hour[getyyyyMMdd(period3)]
                    objArr.push({id_gtp, dt, val})
                }
            }
            await onUpdate(objArr)
            setSeconds(maxValue)
            notify(`Скопировано. Из ${getyyyyMMdd(period3)} в диапазон ${getyyyyMMdd(period4)} – ${getyyyyMMdd(period5)}. Кол-во дней: ${raznDayCount}`, 'success', 5000)
        } catch (e) {
            notify(e.message, 'error', 5000)
            return null
        } finally {
            // setPeriod1(period4)
            // setPeriod2(period5)
            await getDataGrid()
            setVisible(false)
            setUpdatingPanel(false)
        }
    }*/

    const copyDays2 = async() => {
        try {
            setUpdatingPanel(true)
            const res = await copyPasteGTPPlan(kdGtp, period3, period4, period5, selectedDog.kodDog )
            if (res.isOk) {
                notify(res.result, 'success', 3000)
                return null
            } else {
                notify(res.message, 'error', 3000)
            }
         } catch (e) {
            notify(e.message, 'error', 5000)
            return null
        } finally {
            await getDataGrid()
            setVisible(false)
            setUpdatingPanel(false)
        }
    }

    const renderField = (data) => {
        return (
            <TextBox defaultValue={`${data?.name} (${data?.xls_gtp_id})`}/>
        );
    }

    const itemRender = (data) => {
        return (
            <div className="custom-item-wite-space-normal">
                {`${data?.name} (${data?.xls_gtp_id})`}
            </div>
        );
    }

    /*let z = 0;
    async function onUpdate(objArr) {
        setSeconds((prevValue) => prevValue - 1)
        await updGtpPlan(objArr[z].id_gtp, objArr[z].dt, objArr[z].val)
        z++;
        if (z < objArr.length) {
            setTimeout(await onUpdate(objArr), 0);
        }
    }*/

    return (
        <>{visiblePage ?
        <div className={'content-block dx-card responsive-paddings planning-page'}>
            <LoadPanel visible={loading || loadingFile} />
            <i className="dx-icon dx-icon-event icon-header-h3 main-color main-color-light"></i>
            <h3><strong><ZagolovokFromMenu/></strong></h3>
            {kdGtp ?
            <>
                {!planningEnabled &&
                    <div className="alert alert-warning mt-3" role="alert">
                        Форма подачи заявок отключена для данной ГТП администратором.
                    </div>
                }
                <SelectBox labelMode={'floating'} label={'ГТП'} className="big-input"
                           noDataText="Нет данных"
                           placeholder="Выберите ГТП..."
                           dataSource={kdGtps}
                           displayExpr="name"
                           valueExpr="kod_gtp"
                           value={kdGtp}
                           columnAutoWidth={true}
                           onValueChanged={onValueChangedSelectBox}
                            fieldRender={renderField}
                            itemRender={itemRender}
                />
                {messageError &&
                    <div className={`alert alert-danger alert-dismissible mt-4`} role="alert">
                        {messageError}
                        <button type="button" className="close" onClick={()=>{setMessageError(null)}} data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                }
                {planningEnabled && <>
                <div className={`alert alert-primary mt-4`} role="alert" style={{whiteSpace: 'pre-line'}}>
                    {deadlineHintMessage}
                </div>
                <input
                    type="file"
                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    ref={importFileRef}
                    style={{display: 'none'}}
                    onChange={(e) => onImportExcel(e.target.files?.[0])}
                />
                <div className="row mb-2 mt-3" >
                    <div className="col-12">
                        {isMobile ? (
                            /* Мобильный: 3 строки */
                            <div className="planning-mobile-toolbar">
                                <div className="planning-mobile-row">
                                    <DateBox
                                        openOnFieldClick={true}
                                        displayFormat='dd.MM.yyyy'
                                        useMaskBehavior={true}
                                        defaultValue={period1}
                                        value={period1}
                                        label={'Начало:'}
                                        labelMode={'floating'}
                                        min={minDate}
                                        max={maxDate}
                                        onValueChanged={onDateBox1Changed}
                                        dateOutOfRangeMessage={`Диапазон возможных дат ${getddMMyyyy(minDate)} — ${getddMMyyyy(period2)}`}
                                    />
                                    <DateBox
                                        openOnFieldClick={true}
                                        displayFormat='dd.MM.yyyy'
                                        useMaskBehavior={true}
                                        label={'Конец:'}
                                        labelMode={'floating'}
                                        defaultValue={period2}
                                        value={period2}
                                        min={period1}
                                        max={maxDate}
                                        onValueChanged={onDateBox2Changed}
                                        dateOutOfRangeMessage={`Диапазон возможных дат ${getddMMyyyy(period1)} — ${getddMMyyyy(maxDate)}`}
                                    />
                                </div>
                                <div className="planning-mobile-row">
                                    <CheckBox
                                        value={correct}
                                        onValueChanged={(e) => {onValueCorrectChanged(e.value)}}
                                        iconSize={34}
                                        text="Корректировка"
                                    />
                                </div>
                                <div className="planning-mobile-row planning-mobile-row--end">
                                    <Button hint='Подать заявку' text='Подать заявку' icon="email" onClick={onSubmitPlan} />
                                    {showRpp &&
                                        <DropDownButton
                                            text="РПП на месяц"
                                            icon="download"
                                            items={rppMenuItems}
                                            displayExpr="text"
                                            keyExpr="id"
                                            onItemClick={(e) => onRppMonth(e.itemData.id)}
                                        />
                                    }
                                    <Toolbar className="planning-mobile-toolbar-rest">
                                        <Item location="before" locateInMenu="always" widget="dxButton">
                                            <Button hint='Копировать дни' text='Копировать в диапазон' icon="columnproperties" onClick={() => setVisible(true)} />
                                        </Item>
                                        <Item location="before" locateInMenu="always" widget="dxButton">
                                            <Button icon='xlsfile' hint='Выгрузить в Excel' text='Выгрузить в Excel' onClick={()=>{
                                                setLoadExcel(true); getDataGrid().then()}} />
                                        </Item>
                                        <Item location="before" locateInMenu="always" widget="dxButton">
                                            <Button icon='upload' hint='Импорт данных' text='Импорт данных' onClick={() => importFileRef.current?.click()} />
                                        </Item>
                                        <Item location="before" locateInMenu="always" widget="dxButton">
                                            <Button hint='Обновить' text='Обновить' icon="refresh" onClick={()=>{
                                                getDataGrid().then()}} />
                                        </Item>
                                    </Toolbar>
                                </div>
                            </div>
                        ) : (
                            /* Десктоп: одна строка */
                            <Toolbar>
                                <Item location="before" locateInMenu="auto">
                                    <DateBox
                                        openOnFieldClick={true}
                                        displayFormat='dd.MM.yyyy'
                                        useMaskBehavior={true}
                                        defaultValue={period1}
                                        value={period1}
                                        label={'Начало:'}
                                        labelMode={'floating'}
                                        min={minDate}
                                        max={maxDate}
                                        onValueChanged={onDateBox1Changed}
                                        dateOutOfRangeMessage={`Диапазон возможных дат ${getddMMyyyy(minDate)} — ${getddMMyyyy(period2)}`}
                                    />
                                </Item>
                                <Item location="before" locateInMenu="auto">
                                    <DateBox
                                        openOnFieldClick={true}
                                        displayFormat='dd.MM.yyyy'
                                        useMaskBehavior={true}
                                        label={'Конец:'}
                                        labelMode={'floating'}
                                        defaultValue={period2}
                                        value={period2}
                                        min={period1}
                                        max={maxDate}
                                        onValueChanged={onDateBox2Changed}
                                        dateOutOfRangeMessage={`Диапазон возможных дат ${getddMMyyyy(period1)} — ${getddMMyyyy(maxDate)}`}
                                    />
                                </Item>
                                <Item location="before" locateInMenu="auto">
                                    <CheckBox
                                        value={correct}
                                        onValueChanged={(e) => {onValueCorrectChanged(e.value)}}
                                        iconSize={34}
                                        text="Корректировка"
                                    />
                                </Item>
                                <Item location="after" locateInMenu="auto" widget="dxButton">
                                    <Button hint='Подать заявку' text='Подать заявку' icon="email" onClick={onSubmitPlan} />
                                </Item>
                                <Item location="after" locateInMenu="auto" widget="dxButton">
                                    <Button hint='Копировать дни' text='Копировать в диапазон' icon="columnproperties" onClick={() => setVisible(true)} />
                                </Item>
                                {showRpp &&
                                    <Item location="after" locateInMenu="auto">
                                        <DropDownButton
                                            text="РПП на месяц"
                                            icon="download"
                                            items={rppMenuItems}
                                            displayExpr="text"
                                            keyExpr="id"
                                            onItemClick={(e) => onRppMonth(e.itemData.id)}
                                        />
                                    </Item>
                                }
                                <Item location="after" locateInMenu="auto" widget="dxButton">
                                    <Button icon='xlsfile' hint='Выгрузить в Excel' text='Выгрузить в Excel' onClick={()=>{
                                        setLoadExcel(true); getDataGrid().then()}} />
                                </Item>
                                <Item location="after" locateInMenu="auto" widget="dxButton">
                                    <Button icon='upload' hint='Импорт данных' text='Импорт данных' onClick={() => importFileRef.current?.click()} />
                                </Item>
                                <Item location="after" locateInMenu="auto" widget="dxButton">
                                    <Button hint='Обновить' text='Обновить' icon="refresh" onClick={()=>{
                                        getDataGrid().then()}} />
                                </Item>
                            </Toolbar>
                        )}
                    </div>
                </div>
                {/*{correct &&
                    <div className={`alert alert-primary alert-dismissible mb-0 mt-1 ${css}`} role="alert">
                        <h4 className="alert-heading">Внимание!</h4>
                        Изменить поданные ранее значения можно только в сторону уменьшения.
                        <button type="button" className="close" onClick={()=>{setCss('displayNone')}} data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                }*/}
                {canClearPlan && kdGtp && (
                    <div className="row mt-1 mb-2">
                        <div className="col-12 d-flex justify-content-end">
                            <Button
                                text="Очистить планирование"
                                icon="trash"
                                type="danger"
                                stylingMode="outlined"
                                hint="Удалить введённые значения плана и историю отправок за выбранный период"
                                onClick={() => {
                                    const x2 = new Date().ieSetH0().ieAddDays(2)
                                    setClearFrom(x2)
                                    setClearTo(x2)
                                    setClearVisible(true)
                                }}
                            />
                        </div>
                    </div>
                )}
                <div className="row mb-4" >
                    <div className="col-12">
                        <DataGrid id="gridContainer"
                            ref={gridRef}
                            className='mt-2'
                            dataSource={data}
                            keyExpr="hours"
                            showBorders={true}
                            columns={columns}
                            summary={summary}
                            showRowLines={true}
                            onRowUpdating = {(row) => {onRowUpdating(row).then()}}
                            onCellPrepared = {(e) => onCellPrepared(e)}
                            onContentReady = {(e) => onContentReady(e)}
                        >
                            <Sorting mode="none" /> 
                            <KeyboardNavigation
                                enterKeyDirection={'column'}
                                editOnKeyPress={true}
                                enterKeyAction={'startEdit'}
                            />
                            <Paging enabled={false} />
                            <Editing
                                mode="cell"
                                allowUpdating={true}
                                selectTextOnEditStart={true}/>
                            <Column dataField="Phone">
                                <PatternRule
                                    message={'Your phone must have "(555) 555-5555" format!'}
                                    pattern={/^\(\d{3}\) \d{3}-\d{4}$/i}
                                />
                            </Column>
                        </DataGrid>
                    </div>
                </div>
                </>}
            </>
                : <p>Для данного договора планирование потребления не предусмотрено</p>
            }
        </div>
            : <AccessDenied/>}

            <Popup

                visible={visible}
                dragEnabled={true}
                hideOnOutsideClick={false}
                showCloseButton={true}
                showTitle={true}
                onHiding={() => setVisible(false)}
                title="Копировать дни"
                maxWidth={600}
                maxHeight={'90%'}
                height={'auto'}
                titleRender={()=>PopupTitleWithIcon('dx-icon-columnproperties', 'Копировать в диапазон',() => setVisible(false))}
            >
                <ScrollView width='100%' height='100%' className='big-input' >
                    <LoadPanel visible={updatingPanel} message={'Идет обновление данных...'} />
                    <ProgressBar
                        id="progress-bar-status"
                        className={seconds === 0 ? 'complete' : ''}
                        width="100%"
                        min={0}
                        max={maxValue}
                        statusFormat={statusFormat}
                        value={maxValue - seconds}
                    />
                    <div className='row'>
                        <div className='col-sm-6'>
                            <DateBox
                                openOnFieldClick={true}
                                displayFormat='dd.MM.yyyy'
                                useMaskBehavior={true}
                                defaultValue={period3}
                                value={period3}
                                min={new Date('09/01/2024')}
                                max={new Date(new Date().setDate(new Date().getDate() + 33)).ieSetH0()}
                                onValueChanged={(e) => setPeriod3(e.value)}
                                label={'Копировать из:'}
                            />
                        </div>
                        {/*<div className='col-sm-6 mt20xs'>
                            <CheckBox
                                value={copyWeekValue}
                                onValueChanged={(e) => {onWeekCopyChanged(e)}}
                                iconSize={30}
                                text="Копировать неделю"
                            />
                            <br/>
                            <CheckBox className={'mt-2'}
                                value={copyFactValue}
                                onValueChanged={(e) => {setCopyFactValue(e.value)}}
                                iconSize={30}
                                text="Копировать факт"
                            />
                        </div>*/}
                        </div>
                    <hr/>
                        <div className='row mt-4 mb-4'>
                        <div className='col-sm-6'>
                            <DateBox
                                openOnFieldClick={true}
                                displayFormat='dd.MM.yyyy'
                                useMaskBehavior={true}
                                defaultValue={period4}
                                value={period4}
                                min={dnow}
                                max={new Date(new Date().setDate(new Date().getDate() + 33)).ieSetH0()}
                                onValueChanged={(e) => onDateBox4Changed(e)}
                                label={'Копировать в диапазон с:'}
                            />
                        </div>
                        <div className='col-sm-6 mt20xs'>
                            <DateBox
                                openOnFieldClick={true}
                                displayFormat='dd.MM.yyyy'
                                useMaskBehavior={true}
                                defaultValue={period5}
                                value={period5}
                                min={period4}
                                max={new Date(new Date().setDate(new Date().getDate() + 33)).ieSetH0()}
                                onValueChanged={(e) => onDateBox5Changed(e)}
                                label={'Копировать в диапазон по:'}
                            />
                        </div>
                    </div>
                    <h3 className={'float-left'}>Диапазон (дней): {raznDayCount}</h3>
                    <Button width={100} className={'float-right ml-2'} visible={true}  text='Отмена' onClick={() => setVisible(false)} />
                    <Button width={100} className={'float-right'} visible={true}  text='Ок' onClick={()=>copyDays2()} />

                </ScrollView>
            </Popup>

            {/* Попап «Очистить планирование» */}
            <Popup
                visible={clearVisible}
                dragEnabled={true}
                hideOnOutsideClick={false}
                showCloseButton={true}
                onHiding={() => setClearVisible(false)}
                maxWidth={500}
                height={'auto'}
                titleRender={() => PopupTitleWithIcon('dx-icon-trash', 'Очистить планирование', () => setClearVisible(false))}
            >
                <ScrollView width='100%' height='100%'>
                    <LoadPanel visible={clearLoading} message={'Выполняется очистка...'} />
                    <p className="text-danger mb-3">
                        Будут удалены все введённые значения плана <strong>и история отправок</strong> за выбранный период.
                        Действие необратимо.
                    </p>
                    <div className="row">
                        <div className="col-sm-6">
                            <DateBox
                                openOnFieldClick={true}
                                displayFormat='dd.MM.yyyy'
                                useMaskBehavior={true}
                                label={'С:'}
                                labelMode={'floating'}
                                value={clearFrom}
                                min={new Date().ieSetH0().ieAddDays(2)}
                                max={maxDate}
                                onValueChanged={(e) => {
                                    setClearFrom(e.value)
                                    if (e.value > clearTo) setClearTo(e.value)
                                }}
                            />
                        </div>
                        <div className="col-sm-6 mt20xs">
                            <DateBox
                                openOnFieldClick={true}
                                displayFormat='dd.MM.yyyy'
                                useMaskBehavior={true}
                                label={'По:'}
                                labelMode={'floating'}
                                value={clearTo}
                                min={clearFrom}
                                max={maxDate}
                                onValueChanged={(e) => setClearTo(e.value)}
                            />
                        </div>
                    </div>
                    <div className="mt-4 d-flex justify-content-end">
                        <Button width={100} className="mr-2" text='Отмена' onClick={() => setClearVisible(false)} />
                        <Button width={130} type="danger" text='Очистить' onClick={onClearPlan} />
                    </div>
                </ScrollView>
            </Popup>
        </>
    )
}

export default Planning
